import { OPEN_MODAL, CLOSE_MODAL } from '../actionTypes';

export function onOpenModal({ variant }) {
  return {
    type: OPEN_MODAL,
    variant,
  };
}

export function onCloseModal() {
  return {
    type: CLOSE_MODAL,
  };
}
